import type { PreloadFetchPolicy } from 'react-relay';

import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';

import parameters from './__generated__/teamPreviewPanelQuery.graphql';

type EntryPointParams = { cloudId: string };
const fetchPolicy: PreloadFetchPolicy = 'network-only';

const teamPreviewPanelEntryPoint = createEntryPoint({
	root: JSResourceForInteraction(
		() =>
			import(
				/* webpackChunkName: "@atlaskit-internal_@atlassian/entry-point-fixtures/TeamPreviewPanel" */ './index'
			).then((mod) => mod.TeamPreviewPanel),
		{
			moduleId: 'team-preview-panel-entrypoint',
		},
	),
	getPreloadProps: ({ cloudId }: EntryPointParams) => ({
		queries: {
			queryReference: {
				parameters,
				variables: {
					cloudId,
				},
				options: {
					fetchPolicy,
				},
			},
		},
	}),
});

export default teamPreviewPanelEntryPoint;
